import { PaginatedRequestParams } from 'api';
import { Dayjs } from 'dayjs';

export enum UserFilterFormField {
  FullUserName = 'full_user_name',
  PhoneNumber = 'phone_number',
  Role = 'role',
  Company = 'company_id',
  Email = 'email',
}

export type UserFilterFormValues = {
  [UserFilterFormField.FullUserName]: string | undefined;
  [UserFilterFormField.PhoneNumber]: string | undefined;
  [UserFilterFormField.Email]: string | undefined;
  [UserFilterFormField.Role]: string | undefined;
  [UserFilterFormField.Company]: string | undefined;
};

export type UserFilterFormValuesPaginated = UserFilterFormValues &
  PaginatedRequestParams;

export enum MatrialFilterFormField {
  Date = 'date',
  Title = 'Title',
  PhoneNumber = 'phone_number',
  Email = 'email',
  Role = 'role',
  materialtype="Type"
}

export type MatrialFilterFormValues = {
  [MatrialFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [MatrialFilterFormField.Title]: string | undefined; 
  [MatrialFilterFormField.PhoneNumber]: string | undefined;
  [MatrialFilterFormField.Email]: string | undefined;
  [MatrialFilterFormField.Role]: string | undefined;
  [MatrialFilterFormField.materialtype]: string | undefined;

};

export type MatrialFilterFormValuesPaginated = MatrialFilterFormValues &
  PaginatedRequestParams;

export enum MasterFormField {
  Id='UserId',
  Role = 'role',
  Title = 'title',  
  flag = 'flag',
  description = 'description',
  type='type',
  IsActive= 'isActive',
}

export type MasterFormValues = {
  [MasterFormField.Id]?: string | undefined;
  [MasterFormField.Role]: number;
  [MasterFormField.Title]: string;
  [MasterFormField.flag]: string;
  [MasterFormField.type]: string;
  [MasterFormField.description]: string;
  [MasterFormField.IsActive]: boolean;
};









 
  

